import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from './listings';

import { Format } from './loaders/format';

export function AllListings(this: ListingsService): Listing[] {
  return (this.source.value() ?? []).map((l) => Format(l));
}
